<ng-container *ngIf="pieChartData && pieChartData.data.length > 0; else noRelatedEntries">
  <div class="pt-5">
    <h5 [attr.data-test-id]="dataTestIdSuffix + '-related-count'">
      {{ relationType }}
    </h5>
  </div>
  <app-pie-chart [pieChartData]="pieChartData"></app-pie-chart>
</ng-container>

<ng-template #noRelatedEntries>
  <div class="pt-5">
    <h5 [attr.data-test-id]="dataTestIdSuffix + '-no-related-entries'">
      {{ noRelationEntitiesLabel | translate }}
    </h5>
  </div>
</ng-template>
